export default __webpack_public_path__ + "static/media/omega-green.7351c226.svg";